import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TokenService } from 'src/app/services/token/token.service';
import {UtilService} from "../../../services/util/util.service";

@Component({
  selector: 'app-brand-selection',
  templateUrl: './brand-selection.component.html',
  styleUrls: ['./brand-selection.component.scss']
})
export class BrandSelectionComponent implements OnInit, OnChanges, OnDestroy {
  @Output() readonly selectBrand = new EventEmitter<any>();
  brandList: any[] = [];
  @Input() storeId = '';
  readonly brandInputCtrl = new UntypedFormControl('');
  private subscription: Subscription;

  constructor(
    private util: UtilService,
  ) {
    this.subscription = this.brandInputCtrl.valueChanges.subscribe((value: string) => {
      const selectedBrand = this.brandList.find(b => b.id === value);
      this.selectBrand.emit(selectedBrand);
    });

    // this.getBrandsByStoreId();
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
      this.getBrandsByStoreId();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  private async getBrandsByStoreId(): Promise<void> {
    try {
      if (!this.storeId) {
        return;
      }

      const result = await this.util.getBrandByStoreId(this.storeId);
      this.brandList = result || [];
      // this.brandInputCtrl.setValue(this.brandList[0]?.id);
    } catch (error) {
      console.error(error);
      console.warn('Failed to fetch the brands');
    }
  }






}
